import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import helpersNumbers from "../../../helpers/numbers";

function Charge({ charge, rolePersian }) {
  return (
    <div className="px-2 ">
      <div className="d-flex">
        <div className="nav-item d-flex align-items-center px-3 py-2 finance-number">
          <span dir="ltr"> : موجودی </span>
          <span className="px-2 letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(charge)
            )}
          </span>
          <span>تومان</span>
        </div>
        {rolePersian != "بازاریاب" && (
          <div className="d-none d-lg-flex">
            <Link to="/finance/charge" className="btn btn-success">
              افزایش اعتبار{" "}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    charge: state.main.charge,
    rolePersian: state.main.role,
  };
};
export default connect(mapStateToProps, null)(Charge);
